import React from "react";
import { Offcanvas, Badge } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import Moment from "react-moment";

const ViewStudyEmergencyRequestDetail = ({ Show, Hide, Title, unblindData }) => {
  const StatusBadge = ({ status }) => {
    let className = "bg-secondary";
    let dotColor = "#6c757d";

    if (status === "approved") {
      className = "bg-success";
      dotColor = "#198754";
    } else if (status === "pending") {
      className = "bg-warning";
      dotColor = "#daa206";
    } else if (status === "revoked") {
      className = "bg-danger";
      dotColor = "#dc3545";
    }

    return (
      <Badge
        className={`${className} text-capitalize hstack gap-1`}
        style={{ width: "fit-content", fontSize: 10 }}
      >
        <span
          className="d-inline-block rounded-circle"
          style={{ backgroundColor: dotColor }}
        ></span>
        {status}
      </Badge>
    );
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="lg">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title || `Request ${unblindData?.id}`}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Unblind ID</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{unblindData?.unblindNumber}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Site</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{unblindData?.siteName}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Subject</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{unblindData?.subjectName}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Unblinded By</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{unblindData?.unblindByName}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Submitted</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>
              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                {unblindData?.createdAt}
              </Moment>
            </small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Reason</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{unblindData?.reason}</small>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Medical Justification</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{unblindData?.medicalJustification}</small>
          </div>
        </div>

        <hr className="my-3" />

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Status</span>
          </div>
          <div className="col-7">
            <StatusBadge status={unblindData?.status} />
          </div>
        </div>
        {unblindData?.status === "approved" && (
          <>
            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Approved By</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>{unblindData?.approvedByName}</small>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Approved Date</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>
                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                    {unblindData?.approvedDT}
                  </Moment>
                </small>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-5 text-capitalize">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Approved Comment</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>{unblindData?.decisionComment}</small>
              </div>
            </div>
          </>
        )}
        {unblindData?.status === "revoked" && (
          <>
            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Revoke By</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>{unblindData?.revokedByName}</small>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Revoke Date</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>
                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                    {unblindData?.revokedDT}
                  </Moment>
                </small>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-5 text-capitalize">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Revoke Comment</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>{unblindData?.revokedComment}</small>
              </div>
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewStudyEmergencyRequestDetail;